/**
 * IS-BE Claude Theme - Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  initMobileNav();
  initScrollAnimations();
  initVideoAutoplay();
  initHoverMicrocopy();
  initEmailCapture();
  initWholesaleForm();
  initStickyAddToCart();
  initProductVariants();
});

/**
 * Mobile Navigation Toggle
 */
function initMobileNav() {
  const hamburger = document.querySelector('.header-hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (!hamburger) return;

  hamburger.addEventListener('click', function() {
    this.classList.toggle('active');
    mobileMenu.classList.toggle('active');
  });

  // Close menu when clicking links
  const menuLinks = mobileMenu.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', function() {
      hamburger.classList.remove('active');
      mobileMenu.classList.remove('active');
    });
  });
}

/**
 * Scroll Animation Observer
 * Adds .visible class to .fade-up elements when they enter viewport
 */
function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all fade-up elements
  document.querySelectorAll('.fade-up').forEach(el => {
    observer.observe(el);
  });
}

/**
 * Video Autoplay Enforcement
 * Ensures all videos play with muted + playsinline
 */
function initVideoAutoplay() {
  const videos = document.querySelectorAll('video');
  videos.forEach(video => {
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('muted', 'muted');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.muted = true;

    // Try to play video
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.log('Video autoplay prevented:', error);
      });
    }
  });
}

/**
 * Hover Microcopy for Flavor Cards
 * Shows "Signal detected" on can hover
 */
function initHoverMicrocopy() {
  const canElements = document.querySelectorAll('[data-hover]');
  canElements.forEach(el => {
    const hoverText = el.getAttribute('data-hover');

    el.addEventListener('mouseenter', function() {
      const label = document.createElement('div');
      label.className = 'hover-label';
      label.textContent = hoverText;
      label.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(104, 76, 206, 0.9);
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 2px;
        font-weight: 600;
        font-size: 0.9rem;
        white-space: nowrap;
        z-index: 10;
        pointer-events: none;
      `;

      if (!el.parentElement.style.position || el.parentElement.style.position === 'static') {
        el.parentElement.style.position = 'relative';
      }
      el.parentElement.appendChild(label);
    });

    el.addEventListener('mouseleave', function() {
      const label = el.parentElement.querySelector('.hover-label');
      if (label) label.remove();
    });
  });
}

/**
 * Email Capture Form Handling
 */
function initEmailCapture() {
  const forms = document.querySelectorAll('[data-email-capture]');
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(this);
      const action = this.getAttribute('action') || '#';

      // Get success message elements
      const successContainer = this.querySelector('[data-success]');
      const successHeadline = successContainer?.getAttribute('data-success-headline') || 'Transmission received';
      const successText = successContainer?.getAttribute('data-success-subtext') || 'Your 15% code is on the way.';

      // Show success message
      this.style.display = 'none';

      const success = document.createElement('div');
      success.className = 'email-capture-success show';
      success.innerHTML = `
        <h3 style="font-size: 1.5rem; margin-bottom: 0.5rem;">${successHeadline}</h3>
        <p>${successText}</p>
      `;

      this.parentElement.appendChild(success);

      // Try to submit via Shopify form if Klaviyo is configured
      if (window.klaviyo && window.klaviyo.push) {
        const email = this.querySelector('input[type="email"]').value;
        const listId = this.getAttribute('data-list-id');

        if (listId && email) {
          window.klaviyo.push({
            event: 'subscribe',
            params: {
              email: email,
              list_id: listId
            }
          });
        }
      }
    });
  });
}

/**
 * Wholesale Form Handling
 */
function initWholesaleForm() {
  const form = document.querySelector('[data-wholesale-form]');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    // Allow normal form submission to Shopify
    // Just add some client-side validation if needed
    const requiredFields = this.querySelectorAll('[required]');
    let isValid = true;

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        isValid = false;
        field.style.borderColor = '#ff4444';
      } else {
        field.style.borderColor = '';
      }
    });

    if (!isValid) {
      e.preventDefault();
      alert('Please fill in all required fields.');
    }
  });
}

/**
 * Sticky Add to Cart (Mobile)
 * Shows fixed button when product title is out of view
 */
function initStickyAddToCart() {
  const sticky = document.querySelector('.sticky-add-to-cart');
  const productTitle = document.querySelector('.product-title');

  if (!sticky || !productTitle) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        sticky.classList.add('show');
      } else {
        sticky.classList.remove('show');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(productTitle);

  // Wire up sticky button to main add to cart
  const stickyBtn = sticky.querySelector('.sticky-add-btn');
  const mainForm = document.querySelector('[data-product-form]');

  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      mainForm.dispatchEvent(new Event('submit'));
    });
  }
}

/**
 * Product Variant Selection
 */
function initProductVariants() {
  const variantSelects = document.querySelectorAll('.variant-option');

  variantSelects.forEach(option => {
    option.addEventListener('click', function(e) {
      e.preventDefault();

      // Remove active from siblings
      this.parentElement.querySelectorAll('.variant-option').forEach(el => {
        el.classList.remove('selected');
      });

      // Add active to clicked
      this.classList.add('selected');

      // Update hidden variant input
      const variantId = this.getAttribute('data-variant-id');
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }
    });
  });
}

/**
 * Quantity Adjustment Helpers
 */
function handleQuantityChange(input) {
  let value = parseInt(input.value) || 1;
  if (value < 1) value = 1;
  input.value = value;
}

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('quantity-decrease')) {
    const input = e.target.parentElement.querySelector('input[type="number"]');
    input.value = Math.max(1, parseInt(input.value) - 1);
    handleQuantityChange(input);
  }

  if (e.target.classList.contains('quantity-increase')) {
    const input = e.target.parentElement.querySelector('input[type="number"]');
    input.value = parseInt(input.value) + 1;
    handleQuantityChange(input);
  }
});

/**
 * Cart Add Success Toast
 */
function showAddToCartSuccess() {
  const toast = document.createElement('div');
  toast.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #B8FF00;
    color: #030309;
    padding: 1rem 1.5rem;
    border-radius: 4px;
    font-weight: 600;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  `;
  toast.textContent = 'Added to cart!';

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// Add CSS animation keyframes dynamically
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);
